import { ref as S, computed as m, onMounted as M, provide as k, openBlock as c, createElementBlock as u, createElementVNode as n, normalizeClass as l, Fragment as B, renderList as T, unref as y, toDisplayString as A, createCommentVNode as $, createBlock as L, withCtx as O, renderSlot as x } from "vue";
import { kebabCase as P } from "lodash-es";
import { themeProp as U } from "../../composables/useTheme.js";
import { useTracking as j } from "../../composables/useTracking.js";
import { TABS_TYPE_BUTTONS as w, TAB_CLASS_NAME_BUTTONS_SCREEN_SMALL as q, TAB_CLASS_NAME_BUTTONS as z, TAB_CLASS_NAME as h } from "./constants.js";
/* empty css          */
import F from "../../molecules/dropdown/dropdown.vue.js";
const R = { class: "ds-tabs" }, V = ["id", "data-track-component-name", "data-track-text", "aria-selected", "aria-controls", "onClick"], Y = ["id", "data-track-component-name", "data-track-text", "aria-selected", "aria-controls", "onClick"], I = /* @__PURE__ */ Object.assign({
  name: "DsTabs"
}, {
  __name: "tabs",
  props: {
    ...U,
    /**
     * Tabs type, influences the styling of the tab items
     */
    type: {
      type: String,
      default: "",
      validator(t) {
        return !t || t === w;
      }
    },
    /**
     * Tabs label, used for the dropdown label
     */
    label: { type: String, required: !0 },
    /**
     * Tabs screen, influences the styling of the tab items for small screens
     */
    screen: { type: String, required: !0 },
    /**
     * Tabs fullScreenContent, adds the ds-container class around tab items, though tab contents remain un-contained
     * this covers the scenario when a gallery is placed inside tab item
     */
    fullScreenContent: { type: Boolean, default: !1 },
    /**
     * Tabs fullScreen, removes the ds-container class around tab buttons
     * TODO: Maybe merge fullscreenContent and fullScreen in one property
     */
    fullScreen: { type: Boolean, default: !1 },
    /**
     * Tabs with hash, adds hash in url with the slugified tab title
     */
    withHash: { type: Boolean, default: !1 },
    useGrid: {
      type: Boolean,
      default: !1
    },
    useGridContent: {
      type: Boolean,
      default: !1
    },
    useGridDivider: {
      type: Boolean,
      default: !1
    },
    contained: {
      type: Boolean,
      default: !1
    },
    containedContent: {
      type: Boolean,
      default: !1
    },
    containedDivider: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["item-clicked", "dropdown-opened", "dropdown-closed"],
  setup(t) {
    const v = t, { trackingDataProvided: p } = j(), s = S([]), d = S(""), i = m(() => v.type === w), b = m(() => {
      const e = v.screen === "small" ? q : z;
      return i.value ? e : h;
    }), D = m(() => {
      const e = v.screen === "small" ? `${h}--tertiary` : `${h}--secondary`;
      return i.value ? "" : e;
    }), N = m(() => i.value ? "" : v.theme === "dark" ? `${h}--dark` : ""), C = m(() => `${b.value} ${D.value} ${N.value}`), E = m(() => i.value ? "auto" : s.value.length > 5 ? `${5 * 51}px` : `${s.value.length * 51}px`), f = (e, o) => {
      d.value = e.title, s.value.forEach((a) => {
        a.isActive = a.title === e.title;
      }), o && o(), v.withHash && location.hash !== `#${e.slug}` && (location.hash = e.slug);
    }, g = (e) => P(e), G = (e) => {
      s.value.push(e);
    };
    return M(() => {
      if (s.value.length) {
        const e = s.value.find((o) => `#${o.slug}` === location.hash);
        v.withHash && location.hash && e ? f(e) : f(s.value[0]);
      }
    }), k("trackingData", { "component-name": "DsTabs", title: d == null ? void 0 : d.value }), k("registerTab", G), k("activeTab", d), (e, o) => (c(), u("div", R, [
      n("div", {
        class: l([
          { "ds-tabs--buttons": i.value },
          { "ds-background-color-grey-100": e.theme === "grey" },
          { "ds-padding-top-0 ds-md-padding-top-24": !i.value }
        ])
      }, [
        n("div", {
          class: l({ "ds-container": t.contained && !t.fullScreen && (t.screen !== "small" || i.value) })
        }, [
          n("div", {
            class: l({ "ds-grid": t.useGrid && !t.fullScreen })
          }, [
            n("div", {
              class: l({ "ds-grid__col ds-grid__col--12": t.useGrid && !t.fullScreen })
            }, [
              t.screen !== "small" ? (c(), u("div", {
                key: 0,
                role: "tablist",
                "aria-orientation": "horizontal",
                class: l(["ds-tabs__items", { "ds-button-group": i.value }])
              }, [
                (c(!0), u(B, null, T(s.value, (a, r) => (c(), u("button", {
                  id: `tab-${g(a.title)}`,
                  key: `tab-${r}`,
                  "data-track-component-name": y(p)["component-name"] || e.$options.name,
                  "data-track-text": a.title,
                  role: "tab",
                  type: "button",
                  class: l(["tab-item", [C.value, a.isActive ? `${b.value}--active` : ""]]),
                  "aria-selected": a.isActive,
                  "aria-controls": `tab-content-${g(a.title)}`,
                  "data-j-button": "",
                  onClick: (H) => [f(a), e.$emit("item-clicked", { label: a.title })]
                }, [
                  n("span", null, A(a.title), 1)
                ], 10, V))), 128))
              ], 2)) : $("", !0),
              t.screen === "small" && s.value.length ? (c(), L(y(F), {
                key: 1,
                role: "tablist",
                "aria-orientation": "vertical",
                class: "ds-tabs__items",
                "with-border": i.value,
                "full-screen": !i.value,
                width: "100%",
                height: E.value,
                label: t.label,
                text: d.value,
                onDropdownOpened: o[0] || (o[0] = (a) => e.$emit("dropdown-opened", { label: d.value })),
                onDropdownClosed: o[1] || (o[1] = (a) => e.$emit("dropdown-closed", { label: d.value }))
              }, {
                default: O((a) => [
                  (c(!0), u(B, null, T(s.value, (r) => (c(), u("button", {
                    id: `tab-${g(r.title)}`,
                    key: r.title,
                    "data-track-component-name": y(p)["component-name"] || e.$options.name,
                    "data-track-text": r.title,
                    role: "tab",
                    type: "button",
                    class: l(["tab-item", [C.value, r.isActive ? `${b.value}--active` : ""]]),
                    "aria-selected": r.isActive,
                    "aria-controls": `tab-content-${g(r.title)}`,
                    onClick: (H) => f(r, a.close)
                  }, [
                    n("span", null, A(r.title), 1)
                  ], 10, Y))), 128))
                ]),
                _: 1
              }, 8, ["with-border", "full-screen", "height", "label", "text"])) : $("", !0)
            ], 2)
          ], 2)
        ], 2),
        i.value ? $("", !0) : (c(), u("div", {
          key: 0,
          class: l({ "ds-container": t.containedDivider })
        }, [
          n("div", {
            class: l({ "ds-grid": t.useGridDivider })
          }, [
            n("div", {
              class: l({ "ds-grid__col ds-grid__col--12": t.useGridDivider })
            }, o[2] || (o[2] = [
              n("div", { class: "ds-tabs__divider" }, null, -1)
            ]), 2)
          ], 2)
        ], 2))
      ], 2),
      n("div", {
        class: l(["ds-tabs__container", { "ds-container": t.containedContent && !t.fullScreenContent }])
      }, [
        n("div", {
          class: l({ "ds-grid": t.useGridContent && !t.fullScreenContent })
        }, [
          n("div", {
            class: l({ "ds-grid__col": t.useGridContent && !t.fullScreenContent })
          }, [
            x(e.$slots, "default")
          ], 2)
        ], 2)
      ], 2)
    ]));
  }
}), ee = I;
export {
  ee as default
};
